import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { breakpoints } from 'Styles/theme';

export const StyledBox = styled(Box)(
  ({ theme }) => `
    background-color: #3399ff;
    display: flex;
    flex-direction: column;
    text-align: left;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    margin: 0;

    ${theme.breakpoints.up(breakpoints.TABLET)} {
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      transform: none;
    }
  `,
);

export const StyledBoxContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  padding-top: 50px;
`;

export const StyledModalTitle = styled(Typography)`
  font-size: 28px;
  font-weight: 600;
  width: 219px;
  margin-bottom: 32px;
  line-height: inherit;
`;

export const StyledModalText = styled(Typography)`
  margin-bottom: 16px;
  font-size: 16px;
  line-height: inherit;
`;
